import { createReducer } from './util';
import { MODIFY_LOCALE_LANGUAGE } from '../constants';
import state from '../state';

function modify_local_language(state, payload) {
  const { locale_language } = payload;
  return ({
    ...state,
    ...locale_language
  });
}

export default createReducer({ [MODIFY_LOCALE_LANGUAGE]: modify_local_language, }, state.localeLanguage);
